<template>
    <template v-if="menu?.mobileOffcanvasMenu && menu?.desktopOffCanvasMenu">
        <SidebarMobile v-if="isMobile" :items="menu.mobileOffcanvasMenu" :footer-items="menu.footer" />
        <SidebarDesktop v-else :items="menu.desktopOffCanvasMenu" :footer-items="menu.footer" />
    </template>
</template>

<script lang="ts" setup>
import { watch } from "vue";
import { useRoute } from "vue-router";
import SidebarMobile from "@/header/components/organisms/SidebarMobile.vue";
import SidebarDesktop from "@/header/components/organisms/SidebarDesktop.vue";
import useIsBreakpoint from "@/shared/composables/use-is-breakpoint";
import { useHeader } from "@/shared/stores/use-header";
import { Menu } from "@/api/interfaces/menu";

defineProps<{
    menu: Menu;
}>();

const headerStore = useHeader();

const route = useRoute();
const { isMobile } = useIsBreakpoint();

watch(route, () => {
    headerStore.sidebarOpen = false;
});
</script>
